import { useMemo } from 'react'
import { generatePath } from 'react-router-dom'
import ROUTING_PATH from '../../../constants/route'
import { UserRole } from '../../../schema/user'

/**
 * チャットページへのパスを生成するカスタムフック
 * @param role ユーザーロール（OWNER または AGENT）
 * @param contractId 契約ID
 * @returns チャットページへのパス（roleまたはcontractIdがundefinedの場合は空文字）
 */
export const useChatPath = (
  role: UserRole | null | undefined,
  contractId: string | undefined
) => {
  return useMemo(() => {
    if (!role || !contractId) {
      return ''
    }
    const destination =
      role === UserRole.OWNER ? ROUTING_PATH.B0303 : ROUTING_PATH.C0303
    return generatePath(destination, { id: contractId })
  }, [role, contractId])
}
